export const getWidthHeight = (n) => (!num(n) || n > 1 ? n : `${n * 100}%`)
export const num = (n) => typeof n === 'number' && !isNaN(n)
